import {APIService} from '@/services/api.service';
import {Timeslot, GoalItem} from '@mobi-components/global-solution';

export interface ITimeslotsRequest {
  sessionId: string;
  solutionId: string;
  activityId: string;
  problemId: string;
}

export async function getAvailableIntradayTimeSlots(payload: ITimeslotsRequest): Promise<Timeslot[]> {
  try {
    return APIService.get<{results: Timeslot[]}>(`alternative-timeslot`, {
      params: {
        session_id: payload.sessionId,
        problem_id: payload.problemId,
        solution_id: payload.solutionId,
        activity_id: payload.activityId,
      },
    }).then((x) => {
      return (x && x.results) || [];
    });
  } catch (e) {
    return [];
  }
}
export async function getAvailableTimeSlots(payload: GoalItem, sessionId: string): Promise<Timeslot[]> {
  try {
    return APIService.post<{results: Timeslot[]}>(`available-timeslots`, [payload], {
      params: {
        session_id: sessionId,
      },
    }).then((x) => {
      return (x && x.results) || [];
    });
  } catch (e) {
    return [];
  }
}
